<!-- Типовая разбивка страницы -->
<div class="dx-page" [ngClass]="pageStyles">
  <!-- Шапка станицы -->
  <div class="dx-page__header" [ngClass]="pageHeaderStyles">
    <ng-container *ngTemplateOutlet="pageHeaderTemplate || defaultPageHeaderTemplate; context: pageHeaderContext"></ng-container>
  </div>

  <!-- Тело -->
  <div class="dx-page__body" [ngClass]="pageBodyStyles">
    <!-- Боковая вертикальная панель -->
    <div class="dx-page__side"
         *ngIf="showPageSide"
         [ngClass]="pageSideStyles">
      <ng-container *ngTemplateOutlet="pageSideTemplate || defaultPageSideTemplate; context: pageSideContext"></ng-container>
    </div>

    <!-- Область контента -->
    <div class="dx-page__content" [ngClass]="pageContentStyles">
      <ng-container *ngTemplateOutlet="pageContentTemplate || defaultPageContentTemplate; context: pageContentContext"></ng-container>
    </div>
  </div>

  <!-- Футер -->
<!--
  <div class="dx-page__footer" [ngClass]="pageFooterStyles">
    <ng-container *ngTemplateOutlet="pageFooterTemplate || defaultPageFooterTemplate; context: pageFooterContext"></ng-container>
  </div>
-->


  <!-- Дефолтный хэдер страницы -->
  <ng-template #defaultPageHeaderTemplate>
    <div class="dx-default-header_content">
      {{greetings.headerGreeting}}
    </div>
  </ng-template>

  <!-- Дефолтный контейнер под поковик страницы -->
  <ng-template #defaultPageSideTemplate>
    <div class="dx-default-side_content">
      {{greetings.sideGreeting}}
    </div>
  </ng-template>

  <!-- Дефолтный контейнер под контент страницы -->
  <ng-template #defaultPageContentTemplate>
    <div class="dx-default-footer_content">
      {{greetings.contentGreeting}}
    </div>
  </ng-template>

  <!-- Дефолтный футер страницы -->
  <ng-template #defaultPageFooterTemplate>
    <div class="dx-default-content">
      {{greetings.footerGreeting}}
    </div>
  </ng-template>

</div>
